import { RiInformationLine } from '@remixicon/react';
import styles from './InfoLogo.module.css';

const InfoLogo = () => {
  return (
    <div className={styles['info-logo']}>
      <RiInformationLine size={64} color='#A1A1AA' />
    </div>
  );
};

InfoLogo.displayName = 'InfoLogo';

export default InfoLogo;
